import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      chatRef: [],
      reference: null
    }
  },
  getters: {
    chatRef (state) {
      return state.chatRef
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.chatRef = []
    },
    add (state, payload) {
      state.chatRef.push(payload)
    },
    update (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.chatRef, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.chatRef.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var user = this.getters['authUser/user']
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('chats_refs').doc(user.key).collection('refs')
        var reference = dbRef.orderBy('updatedAt', 'desc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              location: change.doc.data().location,
              status: change.doc.data().status,
              type: change.doc.data().type,
              enable: change.doc.data().enable,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            if (change.type === 'added') {
              commit('add', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'modified') {
              commit('update', JSON.parse(JSON.stringify(payload)))
            } else if (change.type === 'removed') {
              commit('remove', JSON.parse(JSON.stringify(payload)))
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var reference = store.getters['chatRef/reference']
        if (reference) {
          reference()
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ChatRef.js